import { useNavigate } from "react-router-dom";
import { useCartWishlist } from "../Context/CartWishlistContext";
import "../styles/Wishlist.css";

const Wishlist = () => {
  const navigate = useNavigate();

  const {
    wishlistCourses,
    removeFromWishlist,
    addToCart,
    wishlistCount
  } = useCartWishlist();

  /* ===== Move to Cart ===== */
  const moveToCart = async (course) => {
    await addToCart(course);
    await removeFromWishlist(course.id);
    navigate("/cart");
  };

  return (
    <div className="wishlist-page">
      <h1>Wishlist</h1>
      {wishlistCourses.length === 0 && (
        <div className="empty-wishlist">
          <h3>No courses in wishlist</h3>
          <button onClick={() => navigate("/courses")}>
            Browse Courses
          </button>
        </div>
      )}

      <div className="wishlist-grid">
        {wishlistCourses.map((course) => (
          <div
            key={course.id}
            className="wishlist-card"
          >
            <div
              onClick={() =>
                navigate(`/courses/${course.id}`)
              }
              className="wishlist-card-body"
            >
              <img
                src={course.thumbnail}
                alt={course.title}
              />

              <h4>{course.title}</h4>
              <p>{course.instructor}</p>

              <div className="price">
                {Number(course.discountedPrice) > 0 ? (
                  <>
                    <span className="discounted">
                      ₹{course.discountedPrice}
                    </span>
                    <span className="original">
                      ₹{course.price}
                    </span>
                  </>
                ) : (
                  <span className="discounted">
                    ₹{course.price}
                  </span>
                )}
              </div>
            </div>

            <div className="wishlist-actions">
              <button
                onClick={() =>
                  removeFromWishlist(course.id)
                }
              >
                Remove
              </button>

              <button
                onClick={() =>
                  moveToCart(course)
                }
              >
                Move to Cart
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Wishlist;
